module.exports = __webpack_public_path__ + "img/android.d1741945.svg";